import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors } from '@/styles'
import { LabeledValue, LabelText } from '@/features/Application/elements'
import StatusComponent from './status-component'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  > :not(:last-child) {
    border-bottom: 1px solid ${colors.grey88};
  }
  > * {
    padding: 12px;
  }
`

const Summary = ({ data, isLocked, isLoading }) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <LabeledValue
        label={
          <LabelText>
            {t('b.liv_score_card.view.identity_verification.label', 'Identity Verification')}
          </LabelText>
        }
        value={
          <StatusComponent status={data?.identity?.details?.[0]?.status} isLocked={isLocked} />
        }
        isLoading={isLoading}
      />
      <LabeledValue
        label={
          <LabelText>
            {t('l.application.view.social_verification.label', 'Social Verification')}
          </LabelText>
        }
        value={
          <StatusComponent
            fallbackText={t('l.application.view.not_connected.label', 'Not connected')}
            status={data?.social?.details?.[0]?.status}
            isLocked={isLocked}
          />
        }
        isLoading={isLoading}
      />
      <LabeledValue
        label={
          <LabelText>
            {t('l.application.view.employment_verification.label', 'Employment Verification')}
          </LabelText>
        }
        value={
          <StatusComponent status={data?.employment?.details?.[0]?.status} isLocked={isLocked} />
        }
        isLoading={isLoading}
      />
      <LabeledValue
        label={
          <LabelText>
            {t('l.application.view.income_verification.label', 'Income Verification')}
          </LabelText>
        }
        value={<StatusComponent status={data?.income?.details?.[0]?.status} isLocked={isLocked} />}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

export default Summary
